/**
 * Canonical formatter for BILLING dates — "Month D, YYYY", UTC-pinned.
 *
 * Billing dates (season start/end, access_end, trial_end, resume date) are
 * authoritative system concepts: the same instant the DB DATE column and the
 * Stripe dashboard show. We render them in UTC so they never depend on the
 * viewer's — or the email server's — timezone. Without the pin, two drifts
 * appear on anything west of UTC:
 *   - a DATE-only value (Postgres DATE "2026-06-18") parses as UTC midnight,
 *     then renders the prior day ("June 17");
 *   - a TIMESTAMPTZ near midnight UTC (a Stripe cycle end) renders the prior day.
 *
 * Used by Settings, the cancel/restore dialogs, and every lifecycle email — one
 * convention so they can't disagree (and so the UTC pin can't be forgotten in
 * one copy, which previously shipped a "June 17 vs June 18" bug in the email).
 *
 * NOT for game dates / "updated X ago" / ambassador timestamps — those use
 * their own (often ET-local) conventions.
 */
export function formatBillingDate(
  d: Date | string,
  month: 'long' | 'short' = 'long',
): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.toLocaleDateString('en-US', {
    month,
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
